import { Edit } from "react-admin";
import * as React from "react";
import { CarCreateForm } from "./CarCreate";

export const CarEdit = () => (
  <Edit>
    <CarCreateForm />
  </Edit>
);
